/**
 * Copyright (c) [2015-2019] SUSE Linux
 *
 * This software may be modified and distributed under the terms
 * of the MIT license.  See the LICENSE.txt file for details.
 */

import React from 'react';
import { Provider, useSelector } from 'react-redux';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';

import store from '../../state/store';

import Login from '../Login';
import Login2 from '../Login2';
import Room from '../Room';
import Contacts from '../Contacts';
import AppStarter from '../AppStarter';
import CallIntegration from '../Call/CallIntegration';
import { ToastProvider } from '../Toast';

import './App.css';

// 私有路由组件：检查登录状态，未登录则跳转到登录页
function PrivateRoute({ children }) {
  const isLogin = useSelector((state) => state.user.isLogin);
  const location = useLocation();
  return isLogin ? children : <Navigate to={`/login${location.search}`} replace />;
}

// 公共路由组件：已登录用户访问登录页等公共页面时跳转到首页
function PublicRoute({ children }) {
  const isLogin = useSelector((state) => state.user.isLogin);
  return isLogin ? <Navigate to="/" replace /> : children;
}

function App() {
  return (
    <Provider store={store}>
      <ToastProvider position="top-right" maxToasts={5}>
        <AppStarter>
          <BrowserRouter>
            <Routes>
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <>
                      <Contacts />
                      {/* 全局通话集成组件，管理所有通话相关界面 */}
                      <CallIntegration />
                    </>
                  </PrivateRoute>
                }
              />
              <Route
                path="/room/:roomId"
                element={
                  <PublicRoute>
                    <>
                      <Room />
                      {/* 全局通话集成组件，管理所有通话相关界面 */}
                    </>
                  </PublicRoute>
                }
              />
              <Route
                path="/login"
                element={
                  <PublicRoute>
                    <Login />
                  </PublicRoute>
                }
              />
              <Route
                path="/login2"
                element={
                  <PublicRoute>
                    <Login2 />
                  </PublicRoute>
                }
              />
            </Routes>
          </BrowserRouter>
        </AppStarter>
      </ToastProvider>
    </Provider>
  );
}

export default App;
